/**
 * Time zones of the IANA database (Europe/Warsaw) to pick from, as the browser knows them, each
 * with its offset from UTC now: "Warsaw — UTC+02:00", grouped by continent. Core takes only
 * these (timezone:all).
 */
const FALLBACK = ['UTC', 'Europe/Warsaw', 'Europe/London', 'Europe/Berlin', 'Europe/Paris', 'Europe/Prague', 'Europe/Kyiv', 'Europe/Vilnius', 'America/New_York', 'America/Chicago', 'America/Los_Angeles', 'Asia/Dubai', 'Asia/Shanghai', 'Asia/Tokyo', 'Australia/Sydney']

export function allTimeZones() {
  try {
    const list = Intl.supportedValuesOf?.('timeZone')
    if (list?.length) return list.includes('UTC') ? list : ['UTC', ...list]
  } catch {
    // an older browser: the common ones
  }
  return FALLBACK
}

/** "UTC+02:00" now in that zone. */
export function zoneOffset(zone, at = new Date()) {
  try {
    const part = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName: 'longOffset' }).formatToParts(at).find((p) => p.type === 'timeZoneName')?.value || 'GMT'
    return part === 'GMT' ? 'UTC+00:00' : part.replace('GMT', 'UTC')
  } catch {
    return ''
  }
}

export const zoneLabel = (zone) => `${zone.split('/').slice(1).join(' / ').replace(/_/g, ' ') || zone} — ${zoneOffset(zone)}`

/** [{group, zones: [{value, label}]}]: the ones given first ("Najczęstsze"), then by continent. */
export function timeZoneGroups(first = [], firstLabel = '') {
  const zones = allTimeZones()
  const top = [...new Set(first.filter((z) => z && zones.includes(z)))]
  const groups = new Map()
  for (const zone of zones) {
    const continent = zone.includes('/') ? zone.split('/')[0] : 'UTC'
    if (!groups.has(continent)) groups.set(continent, [])
    groups.get(continent).push({ value: zone, label: zone.includes('/') ? zoneLabel(zone) : `${zone} — ${zoneOffset(zone)}` })
  }
  const out = [...groups.entries()].sort(([a], [b]) => a.localeCompare(b)).map(([group, list]) => ({ group, zones: list.sort((a, b) => a.label.localeCompare(b.label)) }))
  return top.length ? [{ group: firstLabel, zones: top.map((z) => ({ value: z, label: `${z} — ${zoneOffset(z)}` })) }, ...out] : out
}
